/* ===========================================================
   POLICY PAGE — used by privacy / terms / refund
   =========================================================== */
import React from "react";
import { Breadcrumbs } from "@/components/shell";
import { NETHRA_DATA } from "@/data/data";
import { Icons } from "@/lib/icons";

const { useState: pgUS, useEffect: pgUE, useRef: pgUR } = React;

function PolicyPage({ kind }) {
  const policy = NETHRA_DATA.policies[kind];
  const [activeId, setActiveId] = pgUS(policy.sections[0].id);

  pgUE(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) setActiveId(e.target.id); });
    }, { rootMargin: "-30% 0px -60% 0px" });
    policy.sections.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, [kind]);

  return (
    <>
      <Breadcrumbs items={[{ label: policy.title }]} />
      <div className="container">
        <div className="policy-layout">
          <aside className="policy-toc">
            <div className="policy-toc-h">On this page</div>
            <nav>
              {policy.sections.map((s) => (
                <a key={s.id} href={"#" + s.id} className={activeId === s.id ? "is-active" : ""}>{s.title}</a>
              ))}
            </nav>
            <div style={{ marginTop: 24, padding: 14, background: "var(--paper-2)", borderRadius: 10, fontSize: 12.5, color: "var(--ink-3)", lineHeight: 1.5 }}>
              Need a signed PDF copy for your compliance file? <a href="#" style={{ color: "#0a0a0a", fontWeight: 500 }}>Request from legal</a>
            </div>
          </aside>

          <article className="policy-body">
            <header className="policy-header">
              <div className="kicker" style={{ color: "#0a0a0a" }}>{policy.eyebrow}</div>
              <h1 className="policy-title" style={{ marginTop: 12 }}>{policy.title}</h1>
              <div className="policy-meta">
                <span><Icons.Calendar size={13} stroke={1.7} style={{ verticalAlign: "-2px", marginRight: 6 }} />{policy.updated}</span>
                <span style={{ width: 1, height: 14, background: "var(--line)", display: "inline-block" }} />
                <a href="#" style={{ color: "var(--ink-3)" }}><Icons.Download size={13} stroke={1.7} style={{ verticalAlign: "-2px", marginRight: 6 }} />Download PDF</a>
                <span style={{ width: 1, height: 14, background: "var(--line)", display: "inline-block" }} />
                <a href="#" onClick={(e) => { e.preventDefault(); window.print(); }} style={{ color: "var(--ink-3)" }}>Print</a>
              </div>
            </header>

            {policy.sections.map((s) => (
              <section key={s.id} id={s.id} className="policy-section">
                <h2>{s.title}</h2>
                <p>{s.body}</p>
              </section>
            ))}

            <div className="policy-actions">
              <a href="/pages/policy/privacy.html" className={"btn btn-sm " + (kind === "privacy" ? "btn-primary" : "btn-outline")}>Privacy</a>
              <a href="/pages/policy/terms.html" className={"btn btn-sm " + (kind === "terms" ? "btn-primary" : "btn-outline")}>Terms</a>
              <a href="/pages/policy/refund.html" className={"btn btn-sm " + (kind === "refund" ? "btn-primary" : "btn-outline")}>Refund</a>
            </div>
          </article>
        </div>
      </div>
    </>
  );
}

export { PolicyPage };
